module.exports = "/_next/static/images/video_id_7181152018117987626-0b70448543b9b04a42e2a1b845c2c540.jpg";